import { render, staticRenderFns } from "./Home-2023.vue?vue&type=template&id=b506faa8&scoped=true&"
import script from "./Home-2023.vue?vue&type=script&lang=js&"
export * from "./Home-2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b506faa8",
  null
  
)

export default component.exports